import React, { Component } from "react";

class PriceBar extends Component {
  render() {
    return (
      <div className="price-bar">
        <p>
          <strong>Departure:</strong> Air India 
          <div className="flex-container">
          <p className="timings"> 11:30 → 18:55 | ₹105,300</p>
          </div>
        </p>
       |
        <p>
          <strong>Return:</strong> Air India 
          <p className="timings"> 00:50 → 01:55 | ₹105,300</p>
        </p>
        |
         <p>
          <p>for 2 adult,2 children</p> 
          <div className="flex-container">
          <p className="timings"> Total fare: ₹210,600</p>
          </div>
        </p>
      </div>
    );
  }
}

export default PriceBar;
